import React, { useState } from "react";
import NoData from "../../../../../components/noData/noData";
import CommonTable from "../../../../../components/table/table";
import DefaultButton from "../../../../../components/buttons/defaultButton";
import { Icons } from "../../../../../../utils/icons";
import CommonForm from "../../../../../components/form/form";
import useCommonFetch from "../../../../../../hooks/useCommonFetch";
import CommonModal from "../../../../../components/modals/commonModel";
import {
  scheduleInterview,
  scheduleInterviewList,
} from "../../../../../../services/workspace/recruitment.service";
import toast from "react-hot-toast";

const Interviews = ({ id, rounds = [] }) => {
  const [showModal, setShowModal] = useState(false);
  const closeModal = () => setShowModal(false);
  const [isEditMode, setIsEditMode] = useState(false);
  const [currentRecord, setCurrentRecord] = useState(null);

  const TableHeaderData = [
    { label: "Interview Panel", key: "interview_panel" },
    { label: "Date", key: "date" },
    { label: "Time", key: "time" },
    { label: "Mode", key: "interview_mode" },
    // { label: "Notes", key: "notes" },
    // { label: "Interviewer", key: "interviewer" },
    { label: "Status", key: "status" },
  ];

  const {
    loading,
    data: tableData,
    total: totalData,
    currentPage,
    handleSearchChange,
    handlePageChange,
    fetchData,
  } = useCommonFetch(scheduleInterviewList, {
    dataPath: "jobInterview.data",
    totalPath: "jobInterview.meta.total",
    errorMessage: "Failed to fetch interviews!",
    debounceDelay: 500,
    customParams: { job_application_id: id },

    dataTransformer: (data) => {
      if (!Array.isArray(data)) {
        return { data: [], action: {} };
      }

      const transformedData = data.map((item) => ({
        ...item,
        interview_panel: item.panel,
        date: item.date,
        time: item.time,
        interview_mode: item.mode,
        notes: item.reason,
        interviewer: item.interviewer,
         status: {
          data: item?.status,
          className: "",
          variant: "status",
          customCases: customCase, 
        },
        rawItem: item, 
      }));

      const actionButton = {
        // edit: (item) => handleEdit(item.rawItem),
        // delete: (item) => handleDelete(item.rawItem),
      };

      return { data: transformedData, action: actionButton };
    }, // <-- make sure to close the function
  });

  // Transform rounds to dropdown options
  const roundOptions = rounds.map((round) => ({
    label: round.name || `Round ${round.id}`,
    value: round.id,
  }));

  // Form fields
  const scheduleFields = [
    {
      name: "interview_rounded_id",
      label: "Interview Round",
      type: "select",
      placeholder: "Select round",
      options: roundOptions.length > 0 ? roundOptions : [
        { label: "No rounds available", value: "", isDisabled: true },
      ],
      required: true,
      colSpan: 6,
      onChange: (value, formik) => {
        // Automatically set interview_mode when round changes
        formik.setFieldValue("interview_mode", "online");
      },
    },
    {
      name: "interview_mode",
      label: "Interview Mode",
      type: "select",
      placeholder: "Select mode",
      options: [
        { label: "Online", value: "online" },
        { label: "Walk-in", value: "walk-in" },
      ],
      required: true,
      colSpan: 6,
    },
    {
      name: "interview_link",
      label: "Interview Link",
      type: "text",
      colSpan: 12,
      showIf: (values) => values?.interview_mode && values?.interview_mode !== "walk-in", // Show only after mode is selected and not walk-in
    },
    {
      name: "interview_address",
      label: "Interview Address/Platform",
      type: "text",
      colSpan: 12,
      showIf: (values) => values?.interview_mode && values?.interview_mode !== "online", // Show only after mode is selected and not online
    },

    {
      name: "interview_date",
      label: "Interview Date",
      type: "date",
      required: true,
      colSpan: 6,
    },
    {
      name: "interview_time",
      label: "Interview Time",
      type: "time",
      placeholder: "Select time",
      required: true,
      colSpan: 6,
    },
  ];

const customCase = {
  0: {
    label: "Pending",
    color: "text-blue-600 text-sm",
    bg: "bg-blue-600",
  },
  1: {
    label: "Shortlisted",
    color: "text-green-600 text-sm",
    bg: "bg-green-600",
  },
  2: {
    label: "Scheduled",
    color: "text-indigo-600 text-sm",
    bg: "bg-indigo-600",
  },
  3: {
    label: "On Hold",
    color: "text-yellow-600 text-sm",
    bg: "bg-yellow-600",
  },
  4: {
    label: "Offered",
    color: "text-purple-600 text-sm",
    bg: "bg-purple-600",
  },
  5: {
    label: "Hired",
    color: "text-emerald-600 text-sm",
    bg: "bg-emerald-600",
  },
  6: {
    label: "Rejected",
    color: "text-red-600 text-sm",
    bg: "bg-red-600",
  },
};
  const handleSubmit = async (formValues) => {
    try {
      await scheduleInterview({
        job_application_id: [id],
        interview_link: formValues.interview_link,
        interview_address: formValues.interview_address,
        interview_round_id: formValues.interview_rounded_id || formValues.interview_panel,
        date: formValues.interview_date,
        time: formValues.interview_time,
        mode: formValues.interview_mode,
        reason: formValues.reason || "",
      });

      toast.success("Interview scheduled successfully.");
      setShowModal(false);
      setIsEditMode(false);
      setCurrentRecord(null);
      fetchData({}, true); // Force reload after successful creation
    } catch (err) {
      console.error(err);
      toast.error("Failed to schedule interview.");
    }
  };

  // const handleSubmit = async (statusValue, formValues) => {
  //   try {
  //     await scheduleInterview({
  //       // job_application_id: [data.id], // or data.uuid depending on API
  //       job_application_id: [id], // or data.uuid depending on API
  //       status: statusValue,
  //       panel: formValues.interview_panel,
  //       date: formValues.interview_date,
  //       time: formValues.interview_time,
  //       mode: formValues.interview_mode,
  //       interviewer_id: formValues.interviewers,
  //       // id: data.jobOpening?.id, // or remove if API doesn't need it
  //     });

  //     toast.success("Interview scheduled successfully.");
  //     setScheduleModal(false);
  //     fetchData();
  //   } catch (err) {
  //     toast.error("Failed to schedule interview......");
  //     console.log(err)
  //   }
  // };

  const handleCancel = () => {
    setIsEditMode(false);
    setCurrentRecord(null);
    setShowModal(false);
  };

  return (
    <div className="flex flex-col bg-white rounded-md h-full">
      <div>
        <div className="border-b flex justify-between p-4">
          <h2 className="text-lg font-semibold text-blue-900">
            Interview Details
          </h2>
          <DefaultButton name={Icons.ADD} onClick={() => setShowModal(true)} />
        </div>
        <div className="p-4">
          <CommonTable
            TableHeaderData={TableHeaderData}
            tabledata={tableData.data || []}
            loading={loading}
            action={tableData?.action}
          />
        </div>
      </div>
      {/* ) : (
        <NoData
          title="No Interview Found"
          message="No interview "
          buttonText="Add Interview"
          onClick={() => setShowModal(true)}
        />
      )} */}

      <CommonModal
        onClose={closeModal}
        show={showModal}
        modalSize="xl"
        headerTitle={"Add Interview"}
      >
        <CommonForm
          fields={scheduleFields}
          initialData={currentRecord || {}}
          onSubmit={handleSubmit}
          submitButtonText={isEditMode ? "Update" : "Submit"}
          onCancel={handleCancel}
          cancelButtonText="Cancel"

        />
      </CommonModal>
    </div>
  );
};

export default Interviews;
